type Breadcrumb = {
  event: string;
  meta?: Record<string, any>;
  timestamp: number;
};

class Logger {
  private breadcrumbs: Breadcrumb[] = [];
  private maxBreadcrumbs = 100;

  info(message: string, meta?: Record<string, any>) {
    console.info("[INFO]", message, meta ?? "");
  }

  warn(message: string, meta?: Record<string, any>) {
    console.warn("[WARN]", message, meta ?? "");
  }

  error(message: string, meta?: Record<string, any>) {
    console.error("[ERROR]", message, meta ?? "");
  }

  addBreadcrumb(event: string, meta?: Record<string, any>) {
    const bc: Breadcrumb = { event, meta, timestamp: Date.now() };
    this.breadcrumbs.push(bc);
    if (this.breadcrumbs.length > this.maxBreadcrumbs) {
      this.breadcrumbs.shift();
    }
  }

  getBreadcrumbs(): Breadcrumb[] {
    return [...this.breadcrumbs];
  }

  clearBreadcrumbs() {
    this.breadcrumbs = [];
  }
}

export const logger = new Logger();
export type { Breadcrumb };